import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import pushRouterAction from 'modules/router/actions/push'

export const handleNavigateToOrigin = ({ location, workoutId, dispatch }) => {
  const originMatch = location.state.originMatch
  const pathname = interpolateRouteUtil(
    originMatch.pathname,
    {
      ...originMatch.params,
      workoutId,
      id: workoutId
    }
  )

  dispatch(
    pushRouterAction({
      pathname,
      search: location.state.searchParams || null
    })
  )
}
